/**
 * Created by hp on 2017/8/18.
 */
const defaults = {
    id: 0,
    initialized: false,
    middleInitialized: false,
};

export default (state = defaults, action) => {
    switch(action.type) {
        case 'RELAY_SETTING_ID_INIT':
            return {...state, id: action.payload};
        case 'RELAY_SETTING_DATA_INIT':
            return {...state, initialized: true, ...action.payload};
        case 'RELAY_SETTING_LIST_ID_INIT':
            return {...state, id: action.payload};
        case 'RELAY_SETTING_LIST_DATA_INIT':
            return {...state, middleInitialized: true, ...action.payload};
        case 'RELAY_SETTING_LIST_DATA_MORE':
            return {...state, ...action.payload, relaiers: [...state.relaiers, ...action.payload.relaiers]};
        case 'RELAY_SETTING_LIST_CANCEL_RELAY':
            return {...state, relaiers: action.payload};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/relaySetting.js